import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter  } from 'react-router-dom'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import history from './history'
import Layouts from './layouts'
import { THEME_CONFIG } from './configs/AppConfig';
import { initializeAuth } from 'store/slices/authSlice';
import { GuidedTourProvider } from 'lib/guided-tour/GuidedTourContext';
import GuidedTour from 'lib/guided-tour/GuidedTour';
import './lang'
// import mockServer from './mock' // Disabled to use real API

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

// Disabled MirageJS to use real backend API
// const environment = process.env.NODE_ENV
// if (environment !== 'production') {
//	mockServer({ environment })
// }

// Component to handle auth initialization
const AppInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize auth state from localStorage on app startup
    dispatch(initializeAuth());
  }, [dispatch]);

  return (
    <BrowserRouter history={history}>
      <ThemeSwitcherProvider 
        themeMap={themes} 
        defaultTheme={THEME_CONFIG.currentTheme} 
        insertionPoint="styles-insertion-point"
      >
        <GuidedTourProvider>
          <Layouts />
          <GuidedTour />
        </GuidedTourProvider>
      </ThemeSwitcherProvider>
    </BrowserRouter>
  );
};

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <AppInitializer />
      </Provider>
    </div>
  );
}

export default App;
